module.exports = __webpack_public_path__ + "media/images/loghi/mylba_pos_hor-f25115bc06e9d54471e64d4f433387ad.png";